import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const NewPill: FC<IconProps> = (props) => {
  return (
    <Icon fill={props.fill || 'phthalo'} viewBox="0 0 17 17" {...props} xmlSpace="preserve">
      <path d="M10.3 16.1c-1.5 0-2.9-.6-4.1-1.7L2 10.1C.9 9.1.3 7.6.3 6.1S.9 3.1 2 2 4.5.3 6.1.3c1.5 0 3 .6 4.1 1.7l4.2 4.2c2.2 2.2 2.2 5.9 0 8.1a5.54 5.54 0 0 1-4.1 1.8zM6.1 1.8c-1.1 0-2.2.4-3 1.2S1.9 4.9 1.9 6s.4 2.2 1.2 3l1.6 1.6 6-6-1.6-1.5c-.8-.8-1.9-1.3-3-1.3z" />
    </Icon>
  )
}

export default NewPill
